import { Component, input } from '@angular/core';

// single crawler header
@Component({
  selector: 'app-single-crawler-page-header',
  templateUrl: './single-crawler-page-header.component.html',
  styleUrls: ['./single-crawler-page-header.component.scss'],
})
export class SingleCrawlerPageHeaderComponent {
  readonly title = input('');
  readonly subtitle = input('');
}
